import { render, staticRenderFns } from "./Motd.vue?vue&type=template&id=f7d8983c&scoped=true"
import script from "./Motd.vue?vue&type=script&lang=ts"
export * from "./Motd.vue?vue&type=script&lang=ts"
import style0 from "./Motd.vue?vue&type=style&index=0&id=f7d8983c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d8983c",
  null
  
)

export default component.exports